import ResizableForm from "../../../../spine-cms-vue/src/components/mixins/ResizableForm";
import ComponentWithMetadataRelationMixin from "./mixins/ComponentWithMetadataRelationMixin";

Vue.asyncComponent('bp-metadata-selection',{
    mixins: [ResizableForm,ComponentWithMetadataRelationMixin],
    props: {
        metadataHandler: {
            type: Object,
            required: true
        },
        placeholderHandler: {
            type: Object,
        }
    },
    data() {
        return {
            supportedMetadata: [],
            currentSelectedMetaData: [],
            loading: false,
        }
    },
    computed: {
        blueprintId() {
            return this.$route.params.blueprintId;
        },
        /**
         * An array of selected metadata ids
         * @returns {*[]}
         */
        selectedMetadataIds() {
            return this.currentSelectedMetaData.map(metadata => metadata.id);
        },
        /**
         * Uniquge id for the width in localstorage
         * @return {string}
         */
        localStorageWidthId() {
            return 'editor-metadata-selection-width';
        }
    },
    methods: {
        /**
         * fetch the supported metadata
         * @returns {Promise<void>}
         */
        async getSupportedMetadata() {
            this.loading = true;
            this.supportedMetadata = await this.metadataHandler.getSupportedMetadata();
            this.loading = false;
        },
        /**
         * Go to metadata form
         * @param id
         */
        goToMetadataForm(metadata) {
            if (metadata.settings.hasForm) {
                let relationAddon = 'metadata-form:' + metadata.id + ':new';

                this.goToRoute(relationAddon);
            } else {
                // If we don't have a form we add the metadata to the current selection
                this.addMetadataToSelection(metadata);
            }
        },
        /**
         * Check if this metadata item is selected
         * @param metadata
         * @returns {boolean}
         */
        isSelected(metadata) {
            return this.selectedMetadataIds.includes(metadata.id);
        },
        /**
         * Get selected
         * @param metadata
         * @return {*[]}
         */
        getSelected(metadata) {
            return this.currentSelectedMetaData.filter(selectedMetadata => selectedMetadata.id === metadata.id);
        },
        /**
         * Add the metadata item to the selection list after save of the form
         * @param metadata
         */
        addMetadataToSelection({id, settings}) {
            // get the full object
            let metadata = this.supportedMetadata.find(metadata => metadata.id === id);

            if (metadata.isRepeated) {
                // make sure we don't update the settings in the supportedMetadata object for repeatable fields
                metadata = this.$cloneDeep(metadata);
            }

            // ad the new settings
            metadata.settings = settings;

            // push the current selection
            this.currentSelectedMetaData.push(metadata);
            this.apply();

            this.$nextTick(() => {
                // We need to trigger close on the stacked window
                // otherwise it won't recalculate the depth for the remaining stacked windows
                this.$refs['stacked-window'].close();
            })
        },
        triggerClose() {
            this.$emit('close');
        },
        /**
         * Notify the parent component we want to apply the current selection
         */
        apply() {
            this.$emit('updateMetadata', this.currentSelectedMetaData);
        }
    },
    async created() {
        this.getSupportedMetadata();
        const selectedMetaData = await this.metadataHandler.getMetadata();

        // Set the initial selected values and make sure we unbind them from the parent
        this.currentSelectedMetaData = [...selectedMetaData];
    }
}, 'blueprints/meta/bp-metadata-selection.html');